import { Box } from "@mui/material";
import { Edit, Delete } from "@mui/icons-material";
import KsbActionButton from "../../../2_ksbHub/components/KsbActionButton";
import { useTheme } from "@mui/material/styles";

export default function JahrgangActions({
  jahrgang,
  isMobile,
  isAdmin,
  onEdit,
  onDelete,
}) {
  const theme = useTheme();

  if (!isAdmin) return null;

  return (
    <Box sx={{ mt: 1.5, display: "flex", justifyContent: "flex-end", gap: 1 }}>
      <KsbActionButton
        onClick={() => onEdit(jahrgang)}
        icon={<Edit />}
        label="Klassensatz Bearbeiten"
        size="small"
        sx={{
          bgcolor: theme.palette.primary.main,
          "&:hover": { bgcolor: theme.palette.primary.dark },
        }}
      />

      <KsbActionButton
        onClick={() => onDelete(jahrgang.id)}
        icon={<Delete />}
        label="Löschen"
        size="small"
        confirm={{
          title: "Delete item?",
          message: "Are you sure you want to delete this item?",
        }}
        sx={{
          bgcolor: theme.palette.error.main,
          color: theme.palette.error.contrastText,
          "&:hover": { bgcolor: theme.palette.error.dark },
        }}
      />
    </Box>
  );
}
